import { render, staticRenderFns } from "./TodayDriverTripChart.vue?vue&type=template&id=63e981e7&"
import script from "./TodayDriverTripChart.vue?vue&type=script&lang=js&"
export * from "./TodayDriverTripChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports